import { useEventListener } from 'utils/hooks'

export const useFullScreenListener = (handler: () => void) => {
  useEventListener('webkitfullscreenchange', handler)
  useEventListener('mozfullscreenchange', handler)
  useEventListener('fullscreenchange', handler)
}
